import { Component, OnInit, Inject } from '@angular/core';
import {LOCAL_STORAGE, WebStorageService} from 'angular-webstorage-service';
import { MacroService } from '../../shared/services/macro.service';
import { AlertaService } from '../../alerta/alerta.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-session-terminar',
  templateUrl: './sessionterminar.component.html',
  styleUrls: ['../../app.component.css', './sessionterminar.component.css']
})

export class SessionTerminarComponent implements OnInit {

  public loading = false;

  constructor(
    @Inject(AlertaService) private servicioAlerta: AlertaService,
    @Inject(MacroService) public macroService: MacroService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router:Router) { }

  ngOnInit() {
    this.loading = true;
    const token = this.storage.get("idma");
    this.macroService.cerrarSession(token).subscribe(
      () => {
        this.limpiarStorage();
      }, err => {
        this.controlarError(err);
        this.limpiarStorage();
      });
  }
  private limpiarStorage() {
    this.storage.set("idma", null);
    this.storage.set("idem", null);
    this.storage.set("nmper", null);
    this.storage.set("reload", "1");
    this.storage.set("nmus", null);
    this.storage.set("nomus", null);
    this.storage.set("alertasC", 0);
    this.loading = false;
    this.router.navigate(['session/iniciar']);
  }

  controlarError(error: any) {
    this.servicioAlerta.error(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/session/terminar/sessionterminar.component.ts